import {GameCard} from './communication/PokerProtocol.generated'
import { _siNumber } from './script-utils'
import { CurrencyCode } from './constants'
import {
	formatCurrency as formatCurrencyFromNumberFormat,
	formatLeaderboardScore as formatLeaderboardScoreFromNumberFormat,
	formatWholePart as formatWholePartFromNumberFormat,
} from './number-format'
import { operatorConfig } from './OperatorConfig'

export interface Offset { left : number, top : number }

export namespace Utils {
	export const formatMultipleAmounts = (amount1: string | number, amount2: string | number, separator: string, code: string, includeCode?: boolean) =>
		operatorConfig.formatMultipleAmounts(amount1, amount2, separator, code, includeCode)

	export const formatCurrencyAmount = (amount: string | number, code: string, includeCode = false) =>
		operatorConfig.formatCurrencyAmount(amount, code, includeCode)

	export const formatMultipleAmountsShorthand = (amount1: number, amount2: number, separator: string, code: string) =>
		operatorConfig.formatMultipleAmountsShorthand(amount1, amount2, separator, code)

	export const formatWithSymbol = (amount: string | number, code: string, appendCurrencyName = false) =>
		operatorConfig.formatWithSymbol(amount, code, appendCurrencyName)

	export const getCurrencySymbol = (code: string) =>
		operatorConfig.getCurrencySymbol(code)

    export function isTimeBanditGame(variant : number) : boolean {
    	switch (variant) {
    	case 9:
    	case 10:
    		return true
    	default:
    		return false
    	}
    }
    export function formatCurrencyShorthand(amount: number): string {
    	const shortAmount = _siNumber(Math.floor(amount), amount >= 100000 && amount < 1000000 ? 0 : 1)

    	return shortAmount === 'NaN'
    		? ''
    		: shortAmount
    }
    export const formatCurrency = formatCurrencyFromNumberFormat
    export const formatLeaderboardScore = formatLeaderboardScoreFromNumberFormat
    export const formatWholePart = formatWholePartFromNumberFormat
		export function abbreviateNumber (num: number): string {
			const THOUSAND = 1_000;
			const MILLION = 1_000_000;
			if (num >= MILLION || num * -1 >= MILLION) {
				return (num / MILLION)
					.toFixed(1)
					.replace(/\.0$/, '') + 'M';
			}
			if (num >= THOUSAND || num * -1 >= THOUSAND) {
				return (num / THOUSAND)
					.toFixed(1)
					.replace(/\.0$/, '') + 'K';
			}
			return num.toString();
		}
		export function getCardString(gamecard : GameCard) : string {
    	return getCardStringFromIndices(gamecard.rank, gamecard.suit)
    }
    export function getCardStringFromIndices(rank : number, suit : number) : string {
    	var ranks = '23456789tjqka *'
    	var suits = 'cdhs *'
    	return ranks.charAt(rank) + suits.charAt(suit)
    }
    export function store(name, value) {
    	var store = getStorage()
    	if (store != null) {
    		store.removeItem(name)
    		store.setItem(name, value)
    	}
    }
    export function remove(name) {
    	var store = getStorage()
    	if (store != null) {
    		store.removeItem(name)
    	}
    }
    export function load(name, defaultValue?) {
    	var store = getStorage()
    	if (store != null) {
    		return store.getItem(name)
    	} else if (typeof(defaultValue) !== 'undefined') {
    		return defaultValue
    	} else {
    		return null
    	}
    }
    export function loadBoolean(name, defaultValue) {
    	var val = load(name, defaultValue)
    	if (val != null) {
    		return val == 'true'
    	} else if (typeof(defaultValue) !== 'undefined') {
    		return defaultValue
    	}
    	return false
    }
    export function getStorage() {
    	if (typeof(localStorage) !== 'undefined') {
    		return localStorage
    	}
    	else {
    		return null
    	}
    }
    export function filterMessage(message) {
    	if (message != null) {
    		return message.replace(/[<>"]*/gi, '')
    	}
    	return null
    }
    export function arePopupsEnabled(): boolean {
    	const popup = window.open()

    	if (!popup) return false

    	popup.close()
    	return true
    }

    export function getUrlParams(): Lookup<string> {
    	const queryString = window
    		.location
    		.search
    		.slice(1)

    	if (!queryString) return {}

    	const queryArr = queryString
    		.split('#')[0]
    		.split('&')

    	return queryArr.reduce((result, param) => {
    		const keyValue = param.split('=')
    		// If there is no value we assume it's just a flag (ie. boolean true)
    		result[keyValue[0]] = keyValue[1] === undefined
    			? true
    			: keyValue[1]
    		return result
    	}, {})
    }
    export async function sleep(ms: number) {
    	return new Promise(resolve => setTimeout(resolve, ms))
    }

    export const flatMap = (f, arr) => arr.reduce((x, y) => [...x, ...f(y)], [])

    export function removePlatformCookie(): void {
    	document.cookie = 'platform' + '=; Path=/; Expires=Thu, 01 Oct 1970 00:00:01 GMT;'
    }
}

/**
 * Converts an amount into a formatted string.
 * Includes 'SC' in case of Sweeps. e.g. "SC 1,000".
 */
export function formatCurrency(amount: number, currency: CurrencyCode) {
	return currency === CurrencyCode.SWEEPS
		? `SC ${Utils.formatCurrency(`${amount}`)}`
		: Utils.formatCurrency(`${amount}`)
}

export function mapNegativeBalanceToZero(balance?: number) {
	if (Number.isFinite(balance) && balance > 0) {
		return balance
	} else {
		return 0
	}
}

export function _updateObject<T extends object>(original: T, updated: T): T {
	for (let x in original) {
		const updatedField = updated[x]
		if (typeof (updated[x]) !=='undefined' && updated[x] !== null ) {
			original[x] = updatedField
		}
	}
	return original
}
